<template>
    <div class="companySection">
        <div v-if="$root.globalData" class="companytitle">
            <h3>  {{$root.globalData.keys.industry_unit_title}} </h3>
            <p> {{$root.globalData.keys.industry_unit_description}} </p>
        </div>
        <CardCompany/>
    </div>
</template>

<script>
import CardCompany from "./CardCompany.vue"
export default {
    data() {
        return {

            companyTitle : "برخی از شرکت های  اینیاب",
            companyDesc : "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم",
        };
    },
    computed: {
  
    },
    components: { CardCompany }
}
</script>


<style scoped>
    .companySection {
        width: 100%;
        box-shadow: 0px 0px 30px #0010f5d2;
        margin: 4rem 0 ;
        padding-bottom: 6rem;
        background-image: url(../../assets/images/factory.jpg);
        background-color: #0010f5d2;
        background-blend-mode: overlay;

    }

    .companytitle {
        color: #fff;
        text-align: center;
        padding: 4rem 0;
    }

    .companytitle h3 {
        font-size: 26px;
        padding-bottom:1rem;
    }
</style>